import { render, staticRenderFns } from "./DetailUsagesDeductionsModal.vue?vue&type=template&id=024ac8bf"
import script from "./DetailUsagesDeductionsModal.vue?vue&type=script&lang=js"
export * from "./DetailUsagesDeductionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports